export default "__VITE_ASSET__g2utjq4N__"